// src/config/navItems.js
import {
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  ServerIcon,
  UserIcon,
  PlayCircleIcon
} from '@heroicons/react/24/outline';

export const navItems = [
  { name: 'Trang chủ', href: '/', icon: ClipboardDocumentListIcon, color: 'bg-blue-50', hover: 'hover:bg-blue-100', text: 'text-blue-900', iconColor: 'text-blue-600' },
  { name: 'Giới thiệu', href: '/about', icon: DocumentTextIcon, color: 'bg-green-50', hover: 'hover:bg-green-100', text: 'text-green-900', iconColor: 'text-green-600' },
  { name: 'Liên hệ', href: '/contact', icon: ServerIcon, color: 'bg-purple-50', hover: 'hover:bg-purple-100', text: 'text-purple-900', iconColor: 'text-purple-600' },
  { name: 'Demo', href: 'https://demo.smartera.uk/', external: true, icon: PlayCircleIcon, color: 'bg-orange-50', hover: 'hover:bg-orange-100', text: 'text-orange-900', iconColor: 'text-orange-600' },
  { name: 'Tra cứu', href: '/track', icon: UserIcon, color: 'bg-gray-50', hover: 'hover:bg-gray-100', text: 'text-gray-900', iconColor: 'text-gray-600' },
];
